import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState, useEffect, createContext, useContext } from 'react';
import Home from './pages/homePage';
import CalendarDashboard from './pages/CalendarDashboard';
import Calendar from './pages/calendar';
import Calculator from './pages/calculator';
import Signup from './pages/signup';
import { SidebarProvider } from './partials/sidebarContext';

const IS_PRODUCTION = process.env.NODE_ENV === "production";
const BACKEND_URI = IS_PRODUCTION ? process.env.REACT_APP_API_BASE_URI : "http://localhost:5050";

const UserContext = createContext();

export function useUser() {
    return useContext(UserContext);
}

function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${BACKEND_URI}/user`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const userData = await response.json();
                    setUser(userData);
                }
            } catch (error) {
                console.error('Error checking auth:', error);
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser, loading }}>
            {children}
        </UserContext.Provider>
    );
}

const App = () => {
    return (
        <UserProvider>
            <SidebarProvider>
                <Router>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/calendars" element={<CalendarDashboard />} />
                        <Route path="/calculator" element={<Calculator />} />
                        <Route path="/signup" element={<Signup />}/>
                        <Route path="/calendar/:id" element={<Calendar />} />
                    </Routes>
                </Router>
            </SidebarProvider>
        </UserProvider>
    );
};

export default App;